import { Identifiable, CalendarHolidays, Resource } from "@planzone/dto";
import { LinkedResource, Linker } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";

function unAssignPersonalCalendarHolidays(
  httpClient: HttpClient,
  linker: Linker,
) {
  return (resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<Resource>>>({
        endpoint: `/resources/${resource.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          calendarHolidays: null,
        },
      })
      .then(linker.linkResource);
}

export { unAssignPersonalCalendarHolidays };
